module.exports = __webpack_public_path__ + "img/img-9.0f975a3f.png";